import type { SVGProps } from 'react';

export function NINavigationAccount({
  title,
  ...props
}: { title: string } & SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <title>{title}</title>
      <path
        fill="currentColor"
        d="M20.667 11.667a4.667 4.667 0 1 1-9.335 0 4.667 4.667 0 0 1 9.335 0ZM19.6 16.454A5.958 5.958 0 0 1 16 17.667c-1.353 0-2.6-.456-3.605-1.214C9.681 17.648 8 21.37 8 23h16c0-1.615-1.733-5.337-4.399-6.546Z"
      />
    </svg>
  );
}

export function NINavigationFullCart({
  title,
  ...props
}: { title: string } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <title>{title}</title>
      <path
        fill="currentColor"
        d="M19.286 13.667a5.012 5.012 0 0 0 2.98 3.022L20 22.334h-8l-2.734-6.81A.932.932 0 0 0 8.429 15H8v-1.333h11.286ZM14.653 9a.68.68 0 0 1 .48 1.16l-2.172 2.173h-1.922l3.134-3.135a.68.68 0 0 1 .48-.198Zm2.694 0a.68.68 0 0 1 .48.198l1.38 1.38a5 5 0 0 0-.197 1.726l-2.144-2.144a.68.68 0 0 1 .48-1.16Z"
      />
      <circle cx="24" cy="12" r="3" fill="#0A7BC3" />
    </svg>
  );
}

export function NINavigationCommunity({
  title,
  ...props
}: { title: string } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <title>{title}</title>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21.333 14.666v-1.333h2.666v8h-2V24l-3.555-2.667h-5.11v-2.666h7.999v-4ZM20 17.334h-6.445L10 20v-2.666H8V8h12v9.334Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function NINavigationSupport({
  title,
  ...props
}: { title: string } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <title>{title}</title>
      <path
        fill="currentColor"
        d="m23.513 21.162-7.964-7.963a1.803 1.803 0 0 1-.522-1.41 3.518 3.518 0 0 0-1.019-2.764A3.498 3.498 0 0 0 11.526 8c-.338 0-.677.048-1.003.144l2.113 2.113c.23 1.06-1.306 2.612-2.378 2.378l-2.113-2.113A3.558 3.558 0 0 0 8 11.528a3.512 3.512 0 0 0 3.79 3.5c.521-.04 1.037.151 1.408.523l7.964 7.962a1.662 1.662 0 1 0 2.35-2.351ZM22.333 23a.666.666 0 1 1 0-1.333.666.666 0 0 1 0 1.333Zm-5.29-10.193 3.552-3.545a1.984 1.984 0 0 1 2.817 0 1.994 1.994 0 0 1 .006 2.823l-3.55 3.546-2.825-2.824Zm-2.353 6.12-3.485 3.457a2.195 2.195 0 0 0-.382.516l-.201.387-1.4.713-.555-.556.683-1.43.387-.202c.19-.1.374-.22.526-.372l3.485-3.457.942.944Z"
      />
    </svg>
  );
}

export function NINavigationLocation({
  title,
  ...props
}: { title: string } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 13 18"
      {...props}
    >
      <title>{title}</title>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.5 16.8c1.773 0 5.318-5.892 5.318-10.2 0-4.308-3.034-5.4-5.318-5.4S1.182 2.292 1.182 6.6 4.727 16.8 6.5 16.8Zm0-8.4c.979 0 1.773-.806 1.773-1.8S7.479 4.8 6.5 4.8c-.979 0-1.773.806-1.773 1.8S5.521 8.4 6.5 8.4Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M7.865 17.555C7.5 17.787 7.03 18 6.5 18c-.53 0-1.001-.213-1.365-.445a5.713 5.713 0 0 1-1.07-.915c-.668-.713-1.333-1.673-1.92-2.739C.982 11.791 0 9.035 0 6.6c0-2.475.891-4.2 2.266-5.268C3.586.306 5.202 0 6.5 0s2.915.306 4.234 1.332C12.11 2.4 13 4.125 13 6.6c0 2.435-.982 5.191-2.145 7.301-.587 1.066-1.252 2.027-1.92 2.739a5.713 5.713 0 0 1-1.07.915ZM6.5 7.2c.326 0 .59-.269.59-.6 0-.331-.264-.6-.59-.6a.596.596 0 0 0-.59.6c0 .331.264.6.59.6Zm5.318-.6c0 4.308-3.545 10.2-5.318 10.2-1.773 0-5.318-5.892-5.318-10.2 0-4.308 3.034-5.4 5.318-5.4s5.318 1.092 5.318 5.4Zm-3.545 0c0 .994-.794 1.8-1.773 1.8-.979 0-1.773-.806-1.773-1.8S5.521 4.8 6.5 4.8c.979 0 1.773.806 1.773 1.8Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
